import React from 'react';
import './MoviesPage.css';
import { useEffect, useState } from 'react';
import api from '../utils/api';
import { Link } from 'react-router-dom';
import resolveMediaUrl from '../utils/mediaUrl';
import { getToken } from '../utils/auth';
import FeedbackPanel from './FeedbackPanel';

const MoviesPage = ({
  themeMode = 'night',
  themeMenuOpen = false,
  onToggleThemeMenu,
  onCloseThemeMenu,
  onApplyTheme
}) => {
  const [items, setItems] = useState([]);
  const [feedbackSummaries, setFeedbackSummaries] = useState({});

  const recordHistory = async (item) => {
    if (!getToken()) {
      return;
    }

    try {
      await api.post('/history', {
        itemType: 'movie',
        itemId: item._id
      });
    } catch (_error) {
      // Ignore history write failures in movies page interactions.
    }
  };

  useEffect(() => {
    const load = async () => {
      try {
        const response = await api.get('/movies');
        const nextItems = response.data.items || [];
        setItems(nextItems);

        if (nextItems.length > 0) {
          try {
            const summaryResponse = await api.get('/feedback', {
              params: {
                targetType: 'movie',
                targetIds: nextItems.map((item) => item._id).join(',')
              }
            });
            setFeedbackSummaries(summaryResponse.data?.items || {});
          } catch (_feedbackError) {
            setFeedbackSummaries({});
          }
        } else {
          setFeedbackSummaries({});
        }
      } catch (_error) {
        setItems([]);
        setFeedbackSummaries({});
      }
    };

    load();
  }, []);

  return (
    <div className={`app theme-${themeMode}`}>
      <div className={`movies-page theme-${themeMode}`}>
        <h2>Бичлэгүүд</h2>
        <Link to="/">Эхлэл</Link>
        <div className="row">
          {items.map((item) => (
            <div key={item._id} className="card">
              <h4>{item.title}</h4>
              {item.videoUrl?.match(/\.(png|jpg|jpeg|webp)$/i) ? (
                <img className="media-preview" src={resolveMediaUrl(item.videoUrl)} alt={item.title} onClick={() => recordHistory(item)} />
              ) : (
                <video className="media-preview" controls src={resolveMediaUrl(item.videoUrl)} onPlay={() => recordHistory(item)} />
              )}
              <small>{item.mediaType} | {item.position}</small>
              <FeedbackPanel
                targetType="movie"
                itemId={item._id}
                initialSummary={feedbackSummaries[item._id]}
                compact
                themeMode={themeMode}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MoviesPage;
